import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "512",
  height: "512",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "256",
  cy: "256",
  r: "256",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_icon = _resolveComponent("n-icon")!

  return (_openBlock(), _createBlock(_component_n_icon, { size: _ctx.size }, {
    default: _withCtx(() => [
      (_ctx.networkName === 'alpha dune testnet')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["size"]))
}